import React from "react";
import Buttons from "../components/Buttons";
import Mouse from "../components/Mouse";
import Navigation from "../components/Navigation";
import Project from "../components/Project";

const Project4 = () => {
  return (
    <div>
      <main>
        <Mouse />
        <div className="project">
          <Navigation />
          <Project projectNumber={3} />
          <Buttons left={"/projet-3"} right={"/projet-5"} />
        </div>
      </main>
    </div>
  );
};

export default Project4;
